import React, { useEffect, useRef } from "react";

import ModalPopUp from "../common/ModalPopUp";

import "@/assets/css/fullCalendar.scss";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import No_UpComingBookingsIcon from "../Icons/NoData/No_UpComingBookingsIcon";
import PublishBookedContractDurationIcon from "../Icons/PublishBookedContractDurationIcon";
import { RejectIcon } from "../Icons/RejectIcon";

import { Popover, Tooltip } from "antd";
import { Link } from "react-router-dom";

import {
  fetchUpcomingCandidateDashbord,
  toggleShowUpcomingBookingViewModal,
  setDashboardUpcomingListLoading,
  updateDashboardUpcomingPagination,
  updateDashboardUpcomingFilters,
} from "../../reducers/clientdashboard";
import RunningLateIcon from "../Icons/RunningLateIcon";
import { UpcomingBookingSkeleton } from "../Skeletons/client/UpcomingBookingSkeleton";
import ContractInfoPopup from "../common/client/dashboard/ContractInfoPopup";
import { routingConstants } from "../../Constants/routingConstants";
import useDebounceScroll from "../../utilities/hooks/useDebounceScroll";
import { SearchFilter } from "../common/client/dashboard/SearchFilter";

import { CgSpinnerTwo } from "react-icons/cg";

import LiverTImerForUpcomingShifts from "../common/client/dashboard/LiverTImerForUpcomingShifts";

const DashboardUpcomingBookingModal = () => {
  // const {  } = useSelector(
  //     (state) => state.clientDashboard,
  // );
  const {
    UpcomingBookedDashaboardDataModal,
    showUpcomingBookingsModal,
    isDashboardUpcomingListLoading,
    upComingPagination,
    isUpcomingDashboardPaginationLoading,
  } = useSelector((state) => state.clientDashboard);
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );
  const dispatch = useDispatch();
  const dataTableRef = useRef();

  useEffect(() => {
    return () => {
      dispatch(toggleShowUpcomingBookingViewModal(false));
    };
  }, []);

  const handleOnCloseModal = () => {
    dispatch(
      updateDashboardUpcomingPagination({
        ...upComingPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    // dispatch(setDashboardUpcomingListLoading(true));
    dispatch(toggleShowUpcomingBookingViewModal(false));
  };
  useEffect(() => {
    if (showUpcomingBookingsModal) {
      dispatch(
        updateDashboardUpcomingPagination({
          ...upComingPagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(setDashboardUpcomingListLoading(true));
      dispatch(updateDashboardUpcomingFilters());
      // dispatch(deSelectAllCandidate());
      dispatch(fetchUpcomingCandidateDashbord({}));
      // dispatch(fetchBookedCandidates());
    }
  }, [showUpcomingBookingsModal]); // Ensure dispatch is included to prevent React warnings

  const handleDebounceScroll = useDebounceScroll(() =>
    dispatch(fetchUpcomingCandidateDashbord({})),
  );
  useEffect(() => {
    if (dataTableRef.current) {
      const table = dataTableRef.current.querySelector(
        "._upcomingBookingLazyLoading",
      );
      table.addEventListener("scroll", handleDebounceScroll);
      return () => {
        table.removeEventListener("scroll", handleDebounceScroll);
      };
    }
  }, [handleDebounceScroll]);

  const getName_Role = (
    _name,
    _role,
    _route_id,
    _is_ongoing,
    _running_late_status,
    _is_time_started,
  ) => {
    return (
      <div className="flex w-full items-center">
        <div className="grow overflow-hidden">
          {!clientUserAllPermissions ||
          clientUserAllPermissions.is_allow_to_view_candidate_profile === 1 ? (
            <>
              <Link
                to={routingConstants.candidateDetail(_route_id)}
                className="line-clamp-1 text-base font-semibold leading-[normal] text-black"
              >
                {_name}
              </Link>
            </>
          ) : (
            <span className="line-clamp-1 cursor-default text-base font-semibold leading-[normal] text-black">
              {_name}
            </span>
          )}
        </div>
        <span
          className={`px-2 py-1 text-[12px] font-semibold ${_running_late_status ? "bg-red-200 text-red" : _is_ongoing ? "bg-green-200 text-green" : _is_time_started ? "bg-yellow-200 text-yellow" : "bg-lightblue text-primary"} flex min-h-[24px] min-w-[73px] items-center justify-center rounded-[4px]`}
        >
          {_role}
        </span>
      </div>
    );
  };

  return (
    <ModalPopUp
      show={showUpcomingBookingsModal}
      panelClass="
            max-w-[auto] max-sm:max-w-[400px]
            "
    >
      <div className="dashboardUpcomingBookingmosal_wrapper grid gap-4">
        <div className="flex justify-between pb-1">
          <div className="flex w-full items-baseline justify-between gap-3">
            <div className="flex items-center gap-4">
              <div>
                <h3 className="main-heading !font-semibold !leading-[normal] text-black">
                  {UpcomingBookedDashaboardDataModal.some(
                    (item) => item.is_ongoing == 1,
                  )
                    ? "Upcoming / Ongoing Bookings"
                    : "Upcoming Bookings"}
                </h3>
              </div>
            </div>
            <div className="flex justify-end gap-4">
              <SearchFilter />

              <button
                onClick={handleOnCloseModal}
                className="text-red outline-none ring-0"
              >
                <RejectIcon />
              </button>
            </div>
          </div>
        </div>

        {/* Calendar Navigation */}
        <div
          ref={dataTableRef}
          // className='_upcomingBookingLazyLoading'
        >
          <div
            className={`UpcomingBookings_Wrapper tour-dashboard-upcoming-booking custom-scrollbar-ui _upcomingBookingLazyLoading flex w-full flex-col gap-4 rounded-[10px] bg-white p-4 ${isDashboardUpcomingListLoading ? "overflow-y-hidden" : "!overflow-y-auto"} max-h-[540px]`}
          >
            <div
              className={`DataTable_Wrapper ${!isDashboardUpcomingListLoading && UpcomingBookedDashaboardDataModal?.length == 0 ? "md:grid-cols-1 xl:grid-cols-1" : "md:grid-cols-2 xl:grid-cols-3"} grid grid-cols-1 gap-[16px] xl:gap-[22px]`}
            >
              {isDashboardUpcomingListLoading ? (
                Array.from({ length: 15 }).map((_, index) => (
                  <UpcomingBookingSkeleton key={index} />
                ))
              ) : UpcomingBookedDashaboardDataModal?.length ? (
                UpcomingBookedDashaboardDataModal.map((item, index) => {
                  const {
                    profile_image,
                    role_name,
                    booked_at,
                    candidate_name,
                    contract_start_time,
                    contract_end_time,
                    candidate_email,
                    mobile_phone_number,
                    profile_percent,
                    contract_duration,
                    break_time,
                    licence_no,
                    contract_ref_no,
                    route_contract_id,
                    is_ongoing,
                    route_id,
                    running_late_status = false,
                    candidate_id,
                    running_late_reason,
                    is_time_started,
                    logged_in_time,
                    contract_date,
                  } = item;
                  const contract_date_formatted =
                    moment(contract_date).format("ddd DD") +
                    " <br/> " +
                    moment(contract_date).format("MMM");
                  const breakTime = moment(break_time, "HH:mm:ss").format("mm");
                  let breakTimeSTR = "";
                  if (breakTime === "00") {
                    breakTimeSTR = "No Break";
                  } else {
                    breakTimeSTR = `${breakTime} min break`;
                  }
                  return (
                    <Popover
                      key={index}
                      trigger={"click"}
                      placement="top"
                      getPopupContainer={() =>
                        document.querySelector(
                          ".dashboardUpcomingBookingmosal_wrapper .UpcomingBookings_Wrapper",
                        )
                      }
                      content={
                        <ContractInfoPopup
                          key={index}
                          data={{
                            contract_ref_no,
                            contract_date_formatted,
                            contract_duration,
                            candidate_name,
                            profile_image,
                            role_name,
                            licence_no,
                            profile_percent,
                            contract_start_time,
                            contract_end_time,
                            mobile_phone_number,
                            candidate_email,
                            breakTimeSTR,
                            route_id, // candidate detail route
                            route_contract_id, // contract detail route
                            candidate_id,
                            logged_in_time,
                          }}
                        />
                      }
                    >
                      <div
                        className={`${running_late_status ? "border border-red" : is_ongoing ? "border-2 border-green" : is_time_started ? "border-2 border-yellow-500" : "border border-[#E9F1FD]"} grid cursor-pointer grid-cols-[79px,1fr] overflow-hidden rounded-lg`}
                        key={index}
                      >
                        <div
                          className={`min-h-[83px] ${running_late_status ? "bg-red-200 text-red" : is_ongoing ? "bg-green-200 text-green" : is_time_started ? "bg-yellow-200 text-yellow" : "bg-[#E9F1FD] text-primary"} flex items-center justify-center`}
                        >
                          <span
                            className="text-center text-[16px] font-semibold lg:text-[18px]"
                            dangerouslySetInnerHTML={{
                              __html: contract_date_formatted,
                            }}
                          ></span>
                        </div>
                        <div className="flex grow flex-col items-start justify-start p-[8px_12px_7px]">
                          {getName_Role(
                            candidate_name,
                            role_name,
                            route_id,
                            is_ongoing,
                            running_late_status,
                            is_time_started,
                          )}
                          <div className="flex w-full justify-between">
                            <div className="flex grow flex-col">
                              <span className="w-fit font-normal text-txtColor">
                                {moment(contract_start_time, "HH:mm:ss").format(
                                  "HH:mm",
                                )}{" "}
                                -{" "}
                                {moment(contract_end_time, "HH:mm:ss").format(
                                  "HH:mm",
                                )}
                              </span>
                              {!clientUserAllPermissions ||
                              clientUserAllPermissions.is_allow_to_view_contract_detail ===
                                1 ? (
                                <>
                                  <Link
                                    to={routingConstants.contractDetail(
                                      route_contract_id,
                                    )}
                                    className="w-fit text-[12px] font-normal text-primary"
                                    target="_blank"
                                  >
                                    {contract_ref_no}
                                  </Link>
                                </>
                              ) : (
                                <span className="w-fit cursor-default text-[12px] font-normal text-primary">
                                  {contract_ref_no}
                                </span>
                              )}
                              {/* <Link
                            to={routingConstants.contractDetail(route_contract_id)}
                            className="text-[12px] font-normal text-primary"
                          >
                            {contract_ref_no}
                          </Link> */}
                            </div>
                            {running_late_status ? (
                              <Popover
                                trigger={"hover"}
                                content={
                                  <>
                                    <div className="flex w-[300px] items-center justify-between rounded-lg p-5 text-black">
                                      <p className="text-[14px] font-medium">
                                        {candidate_name} is running late for
                                        shift - Reason:
                                        <span className="font-bold">
                                          {" "}
                                          {running_late_reason}{" "}
                                        </span>
                                      </p>
                                    </div>
                                  </>
                                }
                              >
                                <div className="cursor-pointer pt-[3px]">
                                  <RunningLateIcon cls={"text-red"} />
                                </div>
                              </Popover>
                            ) : is_ongoing ? (
                              <>
                                <Tooltip
                                  // title="The candidate's clock-in time"
                                  title={`${candidate_name} started shift at ${moment(logged_in_time).format("HH:mm")}`}
                                >
                                  <div className="flex items-center gap-1">
                                    <PublishBookedContractDurationIcon
                                      cls={"text-green"}
                                    />
                                    <span className="text-base font-medium text-green">
                                      {moment(logged_in_time).format("HH:mm")}
                                    </span>
                                  </div>
                                </Tooltip>
                              </>
                            ) : is_time_started ? (
                              <LiverTImerForUpcomingShifts
                                contractDate={contract_date}
                                contractStartTime={contract_start_time}
                                contractEndTime={contract_end_time}
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </Popover>

                    // </Popover>
                  );
                })
              ) : (
                <div className="UpcomingBookings_Wrapper flex w-full items-center justify-center">
                  <div className="flex h-[283px] flex-col items-center justify-center rounded-[10px] bg-white">
                    <No_UpComingBookingsIcon />
                    <span className="text-[18px] font-semibold leading-[normal] text-primary">
                      No Upcoming Booking
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {!isDashboardUpcomingListLoading &&
          isUpcomingDashboardPaginationLoading ? (
            <div className="flex items-center justify-center">
              <CgSpinnerTwo className="buttonLoader animate-spin" />
              <span className="ml-2">Loading More..</span>
            </div>
          ) : null}
        </div>
      </div>
    </ModalPopUp>
  );
};

export default DashboardUpcomingBookingModal;
